import { combineReducers } from "redux";
import { authReducer } from "./auth/reducers";
import { toastReducer } from "./common/Toast/reducer";
import { contentReducer } from "./content/reducers";
import { bucketReducer } from "./participant/reducers";
import { profileReducer } from "./participantProfile/reducers";
import { searchReducer } from "./shared/components/Search/reducers";
import categoriesReducer from "./shared/components/categoriesDropdown/reducers";
import { chatReducer } from "./shared/components/chat/reducers/chatReducer";
import { notificationsReducer } from "./shared/components/notifications/reducers";
import { pendingTodosReducer } from "./shared/components/pendingTodos/reducers";
import { reminderSchedulesReducer } from "./shared/components/reminderSchedulesDropdown/reducers";
import { requestReducer } from "./shared/request/reducers";
import { activeCourse, activeLearningPath, data } from "./shared/slices";
import { stripeReducer } from "./stripe/reducers";
import { todosReducer } from "./todos/reducers";

export default combineReducers({
  auth: authReducer,
  request: requestReducer,
  profile: profileReducer,
  bucketReducer,
  todosReducer,
  pendingTodos: pendingTodosReducer,
  categoriesReducer,
  content: contentReducer,
  notificationsReducer,
  chatReducer,
  reminderSchedulesReducer,
  stripeReducer,
  toast: toastReducer,
  search: searchReducer,
  activeLearningPath: activeLearningPath.defaultReducer,
  activeCourse: activeCourse.defaultReducer,
  data: data.defaultReducer,
});
